const DAY_MS = 86_400_000;

/** AAAA-MM-DD em UTC. */
export function toIsoDay(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export function parseIsoDay(day: string): Date {
  return new Date(`${day}T00:00:00Z`);
}

/** Dias inteiros de `from` até `to` (positivo se `to` é depois). */
export function daysBetween(from: string, to: string): number {
  return Math.round((parseIsoDay(to).getTime() - parseIsoDay(from).getTime()) / DAY_MS);
}

export function addDays(day: string, n: number): string {
  return toIsoDay(new Date(parseIsoDay(day).getTime() + n * DAY_MS));
}

/** Hoje no fuso de São Paulo (UTC-3, sem horário de verão desde 2019). */
export function todayInSaoPaulo(now: Date = new Date()): string {
  return toIsoDay(new Date(now.getTime() - 3 * 3_600_000));
}
